/**
 * BaseSection — Base class for the 6 standard sidebar sections.
 *
 * The 6 sections are rendered in fixed order by AppShell:
 *   1. brand      — BrandHeader (logo + tool name)
 *   2. nav        — Back/navigation
 *   3. search     — Primary search input
 *   4. list       — Primary scrollable list
 *   5. functions  — Tool-specific function panels
 *   6. tray       — System tray (locale, theme, info)
 *
 * Each section is self-contained and extends BaseComponent.
 */

import { BaseComponent } from './BaseComponent';

export type SectionId = 'brand' | 'nav' | 'search' | 'list' | 'functions' | 'tray';

export abstract class BaseSection extends BaseComponent {
  abstract readonly sectionId: SectionId;

  /**
   * Optional human-readable title, used by debug tools and accessibility.
   */
  abstract readonly sectionTitle: string;
}
